export default __webpack_public_path__ + "media/Crucible_mobile.4fc4a1a25d73afe641d943f93b04c942.svg";